import React, { useState } from 'react';
import { useMusicPlayerStore } from '../../stores/useUIStore'; // 🟢 1. Importamos el store
import toast from 'react-hot-toast';

const AddMusicModal = ({ isOpen, onClose, onSearch, onAddSong }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  // 🟢 2. Obtenemos el estado y las acciones del nuevo store
  const playTrack = useMusicPlayerStore((state) => state.playTrack);
  const currentTrack = useMusicPlayerStore((state) => state.currentTrack);
  const isPlaying = useMusicPlayerStore((state) => state.isPlaying);
  const resetPlayer = useMusicPlayerStore((state) => state.resetPlayer);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setIsSearching(true);
    const searchResults = await onSearch(query);
    setResults(searchResults);
    setIsSearching(false);
  };

  const handleAddSong = (song) => {
    // onAddSong ahora puede recibir un array de canciones
    onAddSong([song]); // Enviamos la canción como un array de un solo elemento
    handleClose();
  };

  const handleClose = () => {
    setQuery('');
    setResults([]);
    setIsSearching(false);
    if (isPlaying) resetPlayer(); // 🟢 3. Usamos la acción de reseteo del store
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold text-gray-800 mb-4">Añadir Música</h2>

        <div className="flex space-x-2 mb-4">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Busca por título o artista..."
            className="flex-1 border border-gray-300 rounded-md shadow-sm py-2 px-3"
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button
            onClick={handleSearch}
            className="py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 w-24"
            disabled={isSearching}
          >
            {isSearching ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              'Buscar'
            )}
          </button>
        </div>

        <ul className="space-y-2 max-h-64 overflow-y-auto">
          {isSearching ? (
            <div className="text-center p-4 text-gray-500">Buscando...</div>
          ) : results.length > 0 ? (
            results.map((song, index) => (
              <li
                key={song.previewUrl || index}
                className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50"
              >
                <div className="flex items-center space-x-3">
                  <img
                    src={song.albumArtUrl}
                    alt={song.title}
                    className="w-12 h-12 rounded-md object-cover"
                  />
                  <div>
                    <p className="font-semibold text-gray-800">{song.title}</p>
                    <p className="text-sm text-gray-500">{song.artist}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => playTrack(song, results, index)}
                    className="text-gray-500 hover:text-blue-600 text-xl disabled:text-gray-300 disabled:cursor-not-allowed"
                    disabled={!song.previewUrl}
                  >
                    <i
                      className={`fas ${currentTrack?.previewUrl === song.previewUrl && isPlaying ? 'fa-pause-circle text-blue-600' : 'fa-play-circle'}`}
                    ></i>
                  </button>
                  <button
                    onClick={() => handleAddSong(song)}
                    className="text-blue-600 hover:text-blue-800 text-xl"
                  >
                    <i className="fas fa-plus-circle"></i>
                  </button>
                </div>
              </li>
            ))
          ) : (
            !isSearching &&
            query && (
              <div className="text-center p-4 text-gray-500">
                No se encontraron resultados.
              </div>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default AddMusicModal;
